import {makeAutoObservable} from "mobx";

class AfterSaleStore {
    id = 0;
    orderId = 0;
    reason = '';
    status = undefined;
    denialReason = '';
    createTime = 0;
    afterSaleImgList = [];
    order = undefined;
    contact = undefined;

    constructor() {
        makeAutoObservable(this)
    }
}

export default new AfterSaleStore();